<template>
  <div>
    <div class="container-fluid">
      <div class="flex">
        <aside :class="['w-[23%] border-l border-[#15273b] min-h-screen bg-[#15273b]', $store.state.toggleAside ? 'fm:block fm:fixed fm:w-[90%] fm:z-100' : 'fm:hidden']">
          <div class="flex flex-col gap-8 p-4">
            <div class="flex justify-between">
              <div class="flex items-center gap-2">
                <routerLink to="/dashboard">
                  <img :src="$store.state.url + $store.state.user.avatar" class="rounded-full w-[100px] h-[100px] fm:w-[60px] fm:h-[60px]"/>
                </routerLink>
                <div class="flex flex-col gap-2">
                  <span class="text-gray-300 !font-medium fm:text-sm">{{$store.state.user.name}}</span>
                  <span class="text-gray-300 !font-medium fm:text-sm">وضعیت دسترسی:
                    <b class="text-green-500" v-if="$store.state.user.status === 'yes'">فعال</b>
                    <b class="text-red-500" v-else>غیر فعال</b>
                  </span>
                  <span class="text-gray-300 !font-medium fm:text-sm">نقش: <strong class="text-green-500">{{$store.state.user.role}}</strong></span>
                  <span class="text-gray-300 !font-medium fm:text-sm">کد دعوت: <strong class="text-green-500">{{inviteCode}}</strong></span>
                  <span class="text-gray-300 !font-medium fm:text-sm">موجودی کیف پول: <strong class="text-green-500">{{walletAmount}}</strong> ریال</span>
                  <span class="text-gray-300 !font-medium fm:text-sm">بدهکاری: <strong class="text-red-500">{{debtAmount}}</strong> ریال</span>
                </div>
              </div>
              <div class="fd:hidden">
                <span class="cursor-pointer" @click="$store.state.toggleAside = false">
                  <font-awesome-icon icon="fa-solid fa-times" class="icon text-white"/>
                </span>
              </div>
            </div>
          </div>
          <div class="border-b border-[#15273b] w-full py-3"></div>
          <div class="">
            <ul>
              <li :class="['text-gray-300 p-2']">
                <div class="flex items-center justify-between">
                  <routerLink to="/" class="flex items-center gap-1">
                    <span class="text-gray-300"><i class="far fa-home-alt"></i>
                      <font-awesome-icon icon="fa-solid fa-home-alt" class="icon"/>
                    </span>
                    <span class="text-gray-300">خانه</span>
                  </routerLink>
                </div>
              </li>
            </ul>
            <ul class="flex flex-col" v-if="$store.state.user.access === 'admin'">
              <DashboardAside
                  icon="far fa-cubes"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دسته بندی ها"
                  :submenus="[
                      {id:1, title:'لیست دسته بندی ها', route:{name:'Category'}},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['full_manager'])"
                  icon="far fa-link"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="نقش  و دسترسی ها"
                  :submenus="[
                      {id:1, title:'لیست نقش ها', route:{name:'Role'}, perm:'full_manager'},
                      {id:2, title:'لیست دسترسی ها', route:{name:'Permission'}, perm:'full_manager'}
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['users','marketing_special_permissions'])"
                  icon="far fa-users"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="کاربران"
                  :submenus="[
                      {id:1, title:'لیست کاربران', route:{name:'User'}, perm:'users'},
                      {id:2, title:'لیست درخواست های ارتقا و تنزل ', route:{name:'PromotionDemotion'}, perm:'marketing_special_permissions'},
                      {id:3, title:'اتصال کاربران ', route:{name:'ConnectUser'}, perm:'users'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['representative_requests'])"
                  icon="far fa-users"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="درخواست های نمایندگی"
                  :submenus="[
                      {id:1, title:'لیست درخواست های نمایندگی', route:{name:'RepresentativeRequest'}, perm:'representative_requests'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['marketing_roles','marketing_connect_roles','marketing_role_permissions','marketing_role_courses','marketing_role_rewards_penalties','marketing_allowed_buys'])"
                  icon="far fa-store-alt"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="بازاریابی"
                  :submenus="[
                      {id:1, title:'لیست نقش ها', route:{name:'MarketingRole'}, perm:'marketing_roles'},
                      {id:2, title:'اتصال نقش ها', route:{name:'MarketingConnectRole'}, perm:'marketing_connect_roles'},
                      {id:3, title:'تعریف ستاره دهی به نقش ها', route:{name:'MarketingRoleRewardsPenaltie'}, perm:'marketing_role_rewards_penalties'},
                      {id:4, title:'دسترسی مدیر به نماینده', route:{name:'MarketingRolePermission'}, perm:'marketing_role_permissions'},
                      {id:5, title:'دسترسی مدیر به ایجاد آموزش', route:{name:'MarketingRoleCourse'}, perm:'marketing_role_courses'},
                      {id:6, title:'لیست نقش های که اجازه خرید دارند', route:{name:'MarketingAllowedBuy'}, perm:'marketing_allowed_buys'},
                      {id:7, title:'تاریخچه', route:{name:'MarketingHistory'}, perm:'marketing_histories'},
                      {id:8, title:'لیست نمایندگان\ مشتریان\ مدیران', route:{name:'MarketingSpecial'}, perm:'marketing_special_permissions'},

                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['products','product_questions','product_comments'])"
                  icon="far fa-cube"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="محصولات"
                  :submenus="[
                      {id:1, title:'لیست محصولات', route:{name:'Product'}, perm:'products'},
                      {id:2, title:'لیست پرسش ها', route:{name:'ProductQuestion'}, perm:'product_questions'},
                      {id:3, title:'لیست دیدگاه ها', route:{name:'ProductComment'}, perm:'product_comments'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['gifts'])"
                  icon="far fa-cube"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="هدایا"
                  :submenus="[
                      {id:1, title:'لیست هدایا', route:{name:'Gift'}, perm:'gifts'},
                  ]"
              />

              <!-- <DashboardAside
                  v-if="hasPermission(['payment_links'])"
                  icon="far fa-cube"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="لینک پرداخت"
                  :submenus="[
                      {id:1, title:'لیست لینک های پرداخت', route:{name:'PaymentLink'}, perm:'payment_links'},
                  ]"
              /> -->
              <DashboardAside
                  v-if="hasPermission(['stores','store_transactions','store_histories'])"
                  icon="far fa-cubes"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="انبار"
                  :submenus="[
                      {id:1, title:'لیست انبار ها', route:{name:'Store'}, perm:'stores'},
                      {id:2, title:'لیست انتقال ها', route:{name:'StoreTransaction'}, perm:'store_transactions'},
                      {id:3, title:'گزارش انبار', route:{name:'StoreHistory'}, perm:'store_histories'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['transport_types','transports'])"
                  icon="far fa-cubes"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="حمل و نقل"
                  :submenus="[
                      {id:1, title:'لیست انواع حمل و نقل', route:{name:'TransportType'}, perm:'transport_types'},
                      {id:1, title:'لیست تعریف حمل و نقل', route:{name:'Transport'}, perm:'transports'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['sliders','site_configs','pages'])"
                  icon="far fa-cog"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تنظیمات"
                  :submenus="[
                      {id:1, title:'اسلایدر', route:{name:'Slider'}, perm:'sliders'},
                      {id:2, title:'تنظیمات سایت', route:{name:'SiteConfig'}, perm:'site_configs'},
                      {id:3, title:'برگه ها', route:{name:'Page'}, perm:'pages'},
                      {id:4, title:'سوالات متداول', route:{name:'Faq'},perm:'faqs'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['articles','videos'])"
                  icon="far fa-newspaper"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="مقالات و ویدیو ها"
                  :submenus="[
                      {id:1, title:'لیست مقالات', route:{name:'Article'}, perm:'articles'},
                      {id:2, title:'لیست ویدیو ها', route:{name:'Video'}, perm:'videos'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['brands'])"
                  icon="fa-regular fa-video"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="حامیان و همراهان ما"
                  :submenus="[
                      {id:1, title:'لیست حامیان و همراهان ما', route:{name:'Brand'}, perm:'brands'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['report_user_sele','report_product_sele','report_invite','report_wallet'])"
                  icon="far fa-cubes"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="گزارشات" 
                  :submenus="[
                      {id:1, title:'گزارشات فروش', route:{name:'UserSales'}, perm:'report_user_sele'},
                      {id:2, title:'گزارش تعداد محصولات فروخته شده', route:{name:'ProductSales'}, perm:'report_product_sele'},
                      // {id:3, title:'دعوت شده ها', route:{name:'Invite'}, perm:'report_invite'},
                      {id:4, title:'تراکنش های کیف پول', route:{name:'Wallet'}, perm:'report_wallet'},
                  ]"
              />

            </ul>
            <ul class="flex flex-col" v-if="$store.state.user.access === 'principal'">
              <DashboardAside
                  icon="far fa-store-alt"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="بازاریابی"
                  :submenus="[
                      {id:1, title:'لیست همکاران', route:{name:'MarketingColleague'},show:hasMarketingSubUser},
                      {id:2, title:'لیست نمایندگان', route:{name:findRoute()},show:(principalPermissions.length > 0 && principalPermissions.filter(item=>item !== 'special_permission').length > 0)},
                      {id:2, title:'لیست نمایندگان\ مشتریان\ مدیران', route:{name:'MarketingSpecial'},show:(principalPermissions.filter(item=>item === 'special_permission').length > 0)},
                      {id:3, title:'تاریخچه', route:{name:'MarketingHistory'}, perm:'marketing_histories'},
                  ]"
              />
              <DashboardAside
                  v-if="allowedCreateCourse || courseRegister"
                  icon="far fa-book"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دوره ها"
                  :submenus="[
                      {id:1, title:'لیست دوره ها', route:{name:'Course'},show:allowedCreateCourse},
                      {id:2, title:'لیست تکرار دوره', route:{name:'CourseRepate'},show:allowedCreateCourse},
                      {id:3, title:'لیست دوره های من', route:{name:'CourseRegister'}},
                  ]"
              />
            </ul>

            <ul class="flex flex-col">
              <DashboardAside
                  v-if="userHasStar"
                  icon="far fa-store-alt"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="بازاریابی"
                  :submenus="[
                      {id:1, title:'لیست نمایندگان', route:{name:'MarketingPrincipalAgentStore'}},
                  ]"
              />
              <DashboardAside
                  v-if="['agent','customer','principal'].includes($store.state.user.access) || hasPermission(['orders'])"
                  icon="far fa-basket-shopping"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="سفارشات"
                  :submenus="[
                      {id:1, title:'لیست سفارشات', route:{name:'Order'}, perm:$store.state.user.access === 'admin' ? 'orders' : undefined},
                  ]"
              />
              <DashboardAside
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="آدرس ها"
                  :submenus="[
                      {id:1, title:'لیست آدرس ها', route:{name:'Address'}},
                  ]"
              />
              <DashboardAside
                  icon="far fa-user"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="پروفایل"
                  :submenus="[
                      {id:1, title:'پروفایل', route:{name:'Profile'}},
                  ]"
              />
              <DashboardAside
                  v-if="$store.state.user.access === 'admin' ? hasPermission(['transactions','withdrawals']) : true"
                  icon="fa-regular fa-wallet"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="مالی"
                  :submenus="[
                      {id:1, title:'لیست تراکنش ها و شارز کیف پول', route:{name:'Transaction'}, perm:$store.state.user.access === 'admin' ? 'transactions' : undefined},
                      {id:2, title:'درخواست تسویه', route:{name:'Withdrawal'}, perm:$store.state.user.access === 'admin' ? 'withdrawals' : undefined},
                  ]"
              />
              <DashboardAside
                  icon="fa-regular fa-wallet"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تاریخچه ورود ها"
                  :submenus="[
                      {id:1, title:'لیست تاریخچه ورود ها', route:{name:'LoginHistory'}},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['contacts'])"
                  icon="far fa-phone"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تماس با ما"
                  :submenus="[
                      {id:1, title:'لیست تماس با ما', route:{name:'Contact'}, perm:'contacts'},
                  ]"
              />
            </ul>

          </div>
        </aside>
        <div :class="['flex flex-col fm:w-full fd:w-[77%]']">
          <header class="border-b border-gray-300 px-4 py-2 bg-white">
            <div class="flex items-center justify-between fd:justify-end">
              <div class="fd:hidden">
                <span class="cursor-pointer" @click="$store.state.toggleAside = !$store.state.toggleAside">
                    <font-awesome-icon icon="fa-solid fa-bars" class="icon text-xl fm:text-sm"/>
                  </span>
              </div>
              <div class="flex items-center gap-10">
                <div class=" cursor-pointer group relative">
                  <div>
                    <img :src="$store.state.url + $store.state.user.avatar" class="rounded-full w-[40px] h-[40px]"/>
                  </div>
                  <div class="group-hover:block hidden bg-white shadow absolute top-[2.4rem] w-[12rem] left-0 rounded">
                    <ul>
                      <li class="bg-gray-100 p-2 hover:bg-gray-200 text-gray-600 fm:text-sm" @click="logout()">خروج</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <main class="p-4">
            <router-view></router-view>
          </main>

        </div>
      </div>
    </div>
    <Loading :loading="loading" />
  </div>
</template>

<script>
export default {name: "DashboardLayout"}
</script>

<script setup>
import {ref, onMounted, computed} from "vue";
import axios from "@/plugins/axios";
import DashboardAside from "@/components/DashboardAside";
import store from "@/store";
import {useRouter} from "vue-router";
import Loading from "./Loading.vue";

const router = useRouter();
let allowedCreateCourse = ref(false)
let courseRegister = ref(false)
let userHasStar = ref(false)
let hasMarketingSubUser = ref(true)
let principalPermissions = ref([])
let walletAmount = ref(0)
let debtAmount = ref(0)
let inviteCode = ref('')
let loading = ref(false);
onMounted(async () => {
  dashboard()
})

const findRoute = computed(()=>()=>{
  if(principalPermissions.value.filter(item=>item === 'create' || item === 'promote').length > 0){
    return 'MarketingPrincipalAgentStore'
  }else if(principalPermissions.value.filter(item=>item === 'confirm').length > 0){
    return 'MarketingPrincipalAgentConfirm'
  }else if(principalPermissions.value.filter(item=>item === 'connect').length > 0){
    return 'MarketingPrincipalAgentConnect'
  }else if(principalPermissions.value.filter(item=>item === 'view').length > 0){
    return 'MarketingPrincipalAgentView'
  }
})
async function logout() {
  loading.value = true;
  await axios.post(`${store.state.api}logout`,{uuid:localStorage.getItem('basket_uuid')}).then(resp => {
    store.commit('clearStorage')
    localStorage.clear()
    router.push({name: 'Index'})
  })
  loading.value = false;
}

async function dashboard(){
  loading.value = true;
  await axios.get(`${store.state.api}dashboard`).then(resp => {
    let data = resp.data.data;
    hasMarketingSubUser.value = data.has_marketing_sub_user;
    principalPermissions.value = data.principal_permissions;
    allowedCreateCourse.value = data.allowed_create_course;
    courseRegister.value = data.course_register;
    walletAmount.value = data.wallet_amount;
    debtAmount.value = data.debt_amount;
    userHasStar.value = data.user_has_star;
    inviteCode.value = data.invite_code;
    store.state.siteConfig = {'store_detail':data.store_detail, 'social_media':data.social_media};
    if(store.state.siteConfig !== null){
      store.state.siteConfig.store_detail.value_added = parseInt(store.state.siteConfig.store_detail.value_added)
      store.state.siteName = store.state.siteConfig.store_detail.site_name_ir
      store.dispatch('setFavicon',store.state.siteConfig.store_detail.favicon)
    }
  })
  loading.value = false;
}

function hasPermission(_permissions){
  let existPerms = [];
  for(let i = 0; i < _permissions.length; i++){
    for(let j = 0; j < store.state.userPermissions.length; j++){
      if(store.state.userPermissions[j].search(_permissions[i]) > 0){
        existPerms.push(true);
      }
    }
  }
  return existPerms.filter(item=>item).length > 0;
}
</script>